export default __webpack_public_path__ + "static/media/story-5.edc8334f.jpg";